import { Component } from "@angular/core";
import {
    MatLegacyDialogModule,
    MatLegacyDialogRef as MatDialogRef
} from "@angular/material/legacy-dialog";

@Component({
    selector: `app-updated-modal`,
    template: `
        <h1 class="section-heading text-center" mat-dialog-title>
            A new version is available
        </h1>
        <div mat-dialog-content>
            <div
                class="wrapper is-column is-center is-vertical-center text-center"
            >
                <p>
                    <em>InSIght was updated while you were working.</em>
                    Reloading will pick up the latest version. Anything you
                    haven't saved on this page will be lost, so finish up first
                    if you need to &mdash; you can stay here and reload later.
                </p>
            </div>
        </div>
        <div mat-dialog-actions>
            <div class="field is-button-group">
                <button
                    class="btn is-primary"
                    mat-button
                    (click)="this.dialogRef.close(true)"
                >
                    Reload now
                </button>
                <button
                    class="btn is-text"
                    mat-button
                    (click)="this.dialogRef.close(false)"
                >
                    Not yet
                </button>
            </div>
        </div>
    `,
    styles: [
        `
            :host {
                display: flex;
                flex-direction: column;
                height: 100%;
            }
            em {
                display: block;
                color: rgba(210, 32, 48, 0.8);
                font-style: normal;
                font-weight: 700;
            }
        `
    ],
    standalone: true,
    imports: [MatLegacyDialogModule]
})
export class AppUpdatedModal {
    constructor(public dialogRef: MatDialogRef<AppUpdatedModal>) {}
}
